/**
 * Application-detail Default button handoff.
 * Prefer URL `applicant_id` — `window.open(..., 'noopener')` does not share
 * sessionStorage with the opener tab, so session-only handoff is unreliable.
 */
export function readReimbursementsListHandoffFromLocation(
  search?: string,
): { q?: string; past_customer?: string } {
  if (typeof window === 'undefined' && search == null) return {}
  const params = new URLSearchParams(search ?? window.location.search)
  const applicantId = params.get('applicant_id')?.trim()
  const pastCustomer = params.get('past_customer')?.trim()
  const handoff: { q?: string; past_customer?: string } = {}
  if (applicantId) handoff.q = applicantId
  if (pastCustomer) handoff.past_customer = pastCustomer
  return handoff
}
